"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIosSwitch = _interopRequireDefault(require("react-ios-switch"));

// Libraries
var SwitchX = function SwitchX(props) {
  return _react["default"].createElement(_reactIosSwitch["default"], {
    checked: props.isOn,
    onColor: props.onTintColor,
    onChange: props.onChange
  });
}; // --------------------------------------------------
// Props
// --------------------------------------------------


SwitchX.propTypes = {
  onTintColor: _propTypes["default"].string.isRequired,
  isOn: _propTypes["default"].bool.isRequired,
  onChange: _propTypes["default"].func
};
SwitchX.defaultProps = {
  onChange: null
};
var _default = SwitchX;
exports["default"] = _default;